import { modify } from 'mythil/object';


const ROUTER_REPLACE = 'ROUTER_REPLACE';
const ROUTER_PUSH = 'ROUTER_PUSH';

const locationStateMiddleware = store => next => action => {
    switch (action.type) {
        case ROUTER_REPLACE:
        case ROUTER_PUSH:
            next(modify(action, "payload", (payload) => {
                const state = { root: window.location.origin };
                return modify(payload, 'state', ({...payload.state, ...state}))

            }));
            return;

    }

    next(action);
};

export default locationStateMiddleware;